/**<params config data>说明
 * position 控制文本框宽度位置
 *
 * 如果组件要显示video的话，要在对应的page页面添加scroll监听来控制播放，不在组件里添加的原因是有可能会复数引用
 */
import { useRef } from 'react';
import css from './index.module.scss';
import { TextBanner } from '@/components/ProductDetailComponents';
import EFReplayBig from '@/components/UI/svg/Icons/EFReplayBig';
import { createEFPic } from '@/utils/useEFPic';
import Image from '@/components/UI/Image';

const item = {
    title: '576Wh Capacity',
    synopsis: 'Double up or go lightweight.',
    desc: 'RIVER Max has two 288Wh batteries. Detach the bottom one when weight takes priority or leave it on to power twice as much.',
    img_url: '/img/rivermax1.png',
    video_src: '',
    alt: '',
    noUseHtmlAttr: true,
};
const configs = {
    position: 'left',
    margin: 'auto',
    padding: '0',
    isShowVideo: false,
    isShowImage: true,
    autoPlay: false,
    loop: false,
    isWebp: false,
};
export default function TextWithImage(props: any) {
    const { config, data = item } = props;
    const { EFPic } = createEFPic(config?.webpUrl);
    const configTypes = { ...configs, ...config };
    if (!configTypes.imgHeight) {
        configTypes.imgHeight = configTypes.position === 'left' || configTypes.position === 'right' ? '540px' : '630px';
    }
    if (!configTypes.imgWidth) {
        configTypes.imgWidth = configTypes.position === 'left' || configTypes.position === 'right' ? '500px' : '1120px';
    }

    /**
     * @create 2022/9/22
     * @auther E01947
     * @desc 新增 video play
     */
    const videoEl = useRef<HTMLVideoElement>(null);
    const restart = () => {
        if (videoEl.current) videoEl.current.play();
    };

    return (
        <div
            className={`TextWithImage ${css.TextWithImage}`}
            style={{
                margin: configTypes.margin,
                padding: configTypes.position === 'left' || configTypes.position === 'right' ? (data.arr || data.phrase ? '180px 0' : '130px 0') : '0',
            }}
        >
            <div
                className="text-banner-out1"
                key={data.title}
                style={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    flexWrap: 'wrap',
                    flexDirection:
                        configTypes.position === 'left'
                            ? 'row'
                            : configTypes.position === 'right'
                            ? 'row-reverse'
                            : configTypes.position === 'top'
                            ? 'column'
                            : 'column-reverse',
                }}
            >
                <div
                    className="text-banner-out2"
                    style={{
                        width: configTypes.width ? configTypes.width : configTypes.position === 'left' || configTypes.position === 'right' ? '550px' : '924px',
                        marginRight: configTypes.position === 'left' ? '70px' : 'auto',
                        marginLeft: configTypes.position === 'right' ? '70px' : 'auto',
                        marginBottom: configTypes.position === 'top' ? '90px' : '0px',
                        marginTop: configTypes.position === 'bottom' ? '90px' : '0px',
                    }}
                >
                    <TextBanner config={configTypes} data={data} />
                </div>
                <div
                    className="text-banner-image"
                    style={{
                        position: 'relative',
                        height: configTypes.imgHeight,
                        width: configTypes.imgWidth,
                    }}
                >
                    {configTypes.isShowImage && !Array.isArray(data.img_url) && (
                        <Image src={data.img_url} layout="fill" className="fullImgs" alt={data.title ? data.title : data.synopsis} />
                    )}
                    {configTypes.isShowImage && Array.isArray(data.img_url) && (
                        <EFPic name={data.img_url} className="fullImgs" alt={data.title ? data.title : data.synopsis} />
                    )}
                    {configTypes.isShowVideo && (
                        <div className="video-replay" onClick={restart}>
                            <EFReplayBig width="44" height="44" />
                        </div>
                    )}
                    {configTypes.isShowVideo && (
                        <video
                            src={data.video_src}
                            id={data.video_id}
                            muted
                            width={'100%'}
                            height={'100%'}
                            style={{ zIndex: 3 }}
                            autoPlay={configTypes.autoPlay}
                            loop={configTypes.loop}
                            ref={videoEl}
                        />
                    )}
                    {props.children}
                </div>
                {data.tip && (
                    <div className="font-family-bold tip">
                        <p>{data.tip}</p>
                    </div>
                )}
            </div>
        </div>
    );
}
